import React, { useEffect, useState } from "react";
import { InputBox } from "../../components/CustomWidgets/InputBox";

import "../../styles.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import LoadingSpinner from "../Loading";
import { toast } from "react-toastify";
import {
  GetOrderFrom,
  updateOrderFrom,
} from "../../API  Functions/CashierSetup";
import { createRoot } from "react-dom/client";
import { MultiSelectBox } from "../CustomWidgets/SelectBox";
import { DownOutlined } from "@ant-design/icons";
import InventoryOnboardPopup from "../../Popups/InventoryOnboardPopup";
import DeliveryCompanyTable from "./DeliveryCompanyTable";
import { checkPermission } from "../../Utils/permissionHelper";

const DeliveryCompanySetup = ({ retailerDetails }) => {
  const { t, i18n } = useTranslation();

  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id
  );
  const isGinne = useSelector(
    (state) => state?.geneLoginReducer?.isGinneLogin
  );
  const [base64Images, setBase64Images] = useState();
  const [hasChanges, setHasChanges] = useState(false);
  const [isFileValid, setIsFileValid] = useState(false);
  const [loading, setLoading] = useState(false);

  const [Error, setError] = useState(0);

  const [allMethods, setAllMethods] = useState([]);
  const [selectedMethods, setSelectedMethods] = useState([]);
  const [deliveryOptions, setDeliveryOptions] = useState([]);
  const [selectedDeliveryFrom, setSelectedDeliveryFrom] = useState([]);
  const [selfDeliveryData, setSelfDeliveryData] = useState({});
  const [selectedDeliveryAgreement, setSelectedDeliveryAgreement] =
    useState("");
  const [openSelfDeivery, setOpenSelfDeivery] = useState(false);
  const [openStates, setOpenStates] = useState({});

  const deliveryAgreements = [
    { id: 1, name: "Company Delivery" },
    { id: 2, name: "Supermarket Delivery" },
  ];

  useEffect(() => {
    getDeliveryCompany();
  }, []);

  const getDeliveryCompany = async () => {
    try {
      const res1 = await GetOrderFrom({ user_id });
      console.log("GetOrderFrom==>", res1);

      if (res1?.result[0]?.status_code == 200) {
        const deliveryOptions = res1?.result[0]?.pos_order_from || [];
        setDeliveryOptions(deliveryOptions);
        // Filter only items with active: true
        const activeOptions = deliveryOptions.filter(
          (item) => item?.active === true
        );
        setSelfDeliveryData(res1?.result[0]?.self_delivery);
        if (res1?.result[0]?.self_delivery?.active) {
        } else if (activeOptions?.length > 0) {
        }
        setSelectedDeliveryFrom(deliveryOptions);
      } else {
        setDeliveryOptions([]);
        setSelectedDeliveryFrom([]); // Also clear selected if response is not successful
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      setLoading(false);
    }
  };

  const UpdateOrderFrom = async () => {
    try {
      const transformedData = selectedDeliveryFrom?.map((item) => ({
        ...item,
        active: item.active,
        delivery_fee: item.supermarket_delivery ? item?.delivery_fee : 0,
        payment_methods: item.active
          ? item?.payment_methods
            ?.filter((pm) => pm?.active)
            ?.map((pm) => pm.id) || []
          : [],
      }));

      // ✅ Only check for empty payment_methods if the item is active
      const hasMissingPayments = transformedData?.some(
        (item) =>
          item.active &&
          (!item.payment_methods || item.payment_methods.length === 0)
      );

      if (hasMissingPayments) {
        toast.error(
          t("Please select at least one payment method for all active delivery options.")
        );
        return;
      }

      const selfDeliveryPayload = {
        id: selfDeliveryData?.id,
        active: true,
        delivery_fee: selfDeliveryData?.delivery_fee,
        payment_methods:
          selfDeliveryData?.payment_methods
            ?.filter((pm) => pm?.active)
            ?.map((pm) => pm.id) || [],
      };

      if (selfDeliveryPayload?.payment_methods?.length < 1) {
        toast.error(
          t("Please select at least one payment method for Self delivery.")
        );
        return;
      }
      if (selfDeliveryPayload?.delivery_fee < 1) {
        toast.error(
          t("Please add delivery fee for self delivery")
        );
        return;

      }

      const payload = {
        self_delivery: selfDeliveryPayload,
        pos_order_from: transformedData,
      };

      const res1 = await updateOrderFrom(payload);

      if (res1?.result[0]?.status_code == 200) {
        setHasChanges(false);
        showModal("");
        getDeliveryCompany();
      }

      console.log("UpdateOrderFrom =>", res1);
    } catch (error) {
      console.error("Error updating order from:", error);
    } finally {
      setLoading(false);
    }
  };

  const UpdateData = () => {
    if (selectedDeliveryFrom?.length < 1) {
      toast.error("Add atleast one Delivery Method");
      return;
    }
    setLoading(true);
    UpdateOrderFrom();
  };

  const toggleDeliveryFrom = (idsArray) => {
    console.log("idsArray ===>", idsArray);

    setSelectedDeliveryFrom((prev) => {
      const updatedMap = new Map(prev.map((item) => [item.id, item]));

      // First, set active: true for matched IDs
      idsArray.forEach((id) => {
        const matchedItem = selectedDeliveryFrom.find((comp) => comp.id === id);
        if (matchedItem) {
          updatedMap.set(id, { ...matchedItem, active: true });
        }
      });

      // Then, make all others inactive
      updatedMap.forEach((item, id) => {
        if (!idsArray.includes(id)) {
          updatedMap.set(id, { ...item, active: false });
        }
      });

      return Array.from(updatedMap.values());
    });

    setHasChanges(true);
  };

  console.log("selectedDeliveryFrom", selectedDeliveryFrom);

  const togglePaymentMethod = (deliveryId, methodName) => {
    setSelectedDeliveryFrom((prev) =>
      prev.map((delivery) => {
        if (delivery.id === deliveryId) {
          return {
            ...delivery,
            payment_methods: delivery.payment_methods.map((method) =>
              method.name === methodName
                ? { ...method, active: !method.active }
                : method
            ),
          };
        }
        return delivery;
      })
    );
    setHasChanges(true);
  };

  const toggleDeliveryAgreement = (methodName, isSuperMarketDelivery) => {
    setSelectedDeliveryFrom((prev) =>
      prev.map((delivery) =>
        delivery.name === methodName
          ? { ...delivery, supermarket_delivery: isSuperMarketDelivery }
          : delivery
      )
    );
    setHasChanges(true);
  };
  console.log("selected==>", selectedDeliveryFrom);

  const toggleSelfDeliveryPaymentMethod = (id) => {
    setSelfDeliveryData((prev) => ({
      ...prev,
      payment_methods: prev.payment_methods.map((method) =>
        method.id === id ? { ...method, active: !method.active } : method
      ),
    }));

    setHasChanges(true);
  };

const handleInputChange = (deliveryId, field, value) => {
  // Allow only numbers with up to 2 decimal places
  const regex = /^\d*\.?\d{0,2}$/;

  if (!regex.test(value)) return;

  // Allow empty string
  if (value === "") {
    setSelectedDeliveryFrom((prev) =>
      prev.map((delivery) =>
        delivery.id === deliveryId ? { ...delivery, [field]: "" } : delivery
      )
    );
    setHasChanges(true);
    return;
  }

  const number = parseFloat(value);

  // Prevent invalid numbers
  if (isNaN(number) || number < 0) return;

  // Commission max 100
  if (field === "commission_range" && number > 100) return;

  // Store as STRING (important)
  setSelectedDeliveryFrom((prev) =>
    prev.map((delivery) =>
      delivery.id === deliveryId ? { ...delivery, [field]: value } : delivery
    )
  );

  setHasChanges(true);
};

  const handleSelfDeliveryInputChange = (field, value) => {
    // Allow only numbers (including decimals)
    const numericValue = value.replace(/[^0-9.]/g, "");

    if (numericValue === "") {
      setSelfDeliveryData((prev) => ({
        ...prev,
        [field]: "",
      }));
      setHasChanges(true);
      return;
    }

    const number = parseFloat(numericValue);
    if (isNaN(number) || number < 0) return;

    setSelfDeliveryData((prev) => ({
      ...prev,
      [field]: number,
    }));

    setHasChanges(true);
  };

  console.log("selfDeliveryData==>", selfDeliveryData);

  const showModal = (message) => {
    const modalContainer = document.createElement("div");
    document.body.appendChild(modalContainer);

    const root = createRoot(modalContainer);

    const handleClose = () => {
      root.unmount(); // Unmount the React component
      document.body.removeChild(modalContainer); // Remove the container from the DOM
    };

    root.render(
      <InventoryOnboardPopup message={message} onClose={handleClose} />
    );
  };
  const showCompanies = true;
  return (
    <div>
      {loading && <LoadingSpinner />}
      {retailerDetails?.status == "approved" ? (
        <div className=" mb-14 mt-4  mx-4">
          {showCompanies === true && selectedDeliveryFrom?.length > 0 && (
            <div className="md:w-full min-h-auto bg-[#FFFFFF] border  rounded-tr-xl rounded-tl-xl mt-5">
              <div className="w-full h-10 bg-[#C9ECF7] px-4  flex items-center font-medium text-base rounded-tr-xl rounded-tl-xl text-[#272728]">
                {t("Choose Company Name")}
              </div>
              <div className="flex flex-wrap mx-4 pb-6 pt-4">
                <MultiSelectBox
                  //   label={t("S")}
                  name="categories"
                  onChange={(event) => {
                    console.log("categories==>", event.target.value);
                    toggleDeliveryFrom(event.target.value);
                  }}
                  placeholder={t("Select Companies")}
                  defaultValue={[
                    ...selectedDeliveryFrom
                      ?.filter((option) => option.active)
                      ?.map((item) => ({
                        value: item?.id,
                        label: t(item?.name),
                      })),
                  ]}
                  options={[
                    ...deliveryOptions?.map((item) => ({
                      value: item?.id,
                      label: t(item?.name),
                    })),
                  ]}
                />
              </div>
            </div>
          )}

          <div className="md:w-full min-h-auto bg-[#FFFFFF] border mb-4 cursor-pointer">
            <div
              onClick={() => setOpenSelfDeivery(!openSelfDeivery)}
              className="w-full h-10 bg-[#C9ECF7] px-4  flex justify-between items-center font-medium text-base text-[#272728]"
            >
              {t("Self-Delivery")}
              <DownOutlined
                className={`transition-transform duration-300 ${openSelfDeivery ? "rotate-180" : "rotate-0"
                  }`}
              />
            </div>
            {openSelfDeivery && (
              <div className="mt-4">
                <label className="font-medium text-base cursor-pointer m-3">
                  {t("Choose Payment Type")}
                </label>

                <div className="flex flex-wrap mx-4 pb-2 pt-4">
                  {selfDeliveryData?.payment_methods
                    ?.filter((method) => method.name !== "Cash & Bank" && method.name !== "Credit") // Filter out the unwanted methods
                    .map((method) => (
                      <div
                        key={method.id}
                        className="pe-3"
                        onClick={() => toggleSelfDeliveryPaymentMethod(method.id)}
                      >
                        <div
                          className={`flex items-center h-10 justify-center gap-2 mt-2 px-4 py-2 text-l font-semibold rounded-3xl border shadow-sm cursor-pointer ${method?.active
                            ? "text-white bg-blue-900 border-blue-900"
                            : "bg-white border border-[#C6C6C6] text-zinc-600"
                            }`}
                        >
                          <label className="font-medium text-base cursor-pointer">
                            {t(method.name)}
                          </label>
                        </div>
                      </div>
                    ))}
                  {/* {selfDeliveryData?.payment_methods?.map((method) => (
                    <div
                      key={method.id}
                      className="pe-3"
                      onClick={() => toggleSelfDeliveryPaymentMethod(method.id)}
                    >
                      <div
                        className={`flex items-center h-10 justify-center gap-2 mt-2 px-4 py-2 text-l font-semibold rounded-3xl border shadow-sm cursor-pointer ${method?.active
                          ? "text-white bg-blue-900 border-blue-900"
                          : "bg-white border border-[#C6C6C6] text-zinc-600"
                          }`}
                      >
                        <label className="font-medium text-base cursor-pointer">
                          {t(method.name)}
                        </label>
                      </div>
                    </div>
                  ))} */}
                </div>

                <div className="flex items-center justify-between pb-4">
                  <div className="w-1/2 mx-4">
                    <InputBox
                      label={t("delivery_fee")}
                      name="storename"
                      placeholder={t("Enter Delivery Fee")}
                      maxLength={20}
                      value={selfDeliveryData.delivery_fee || ""}
                      onChange={(e) =>
                        handleSelfDeliveryInputChange(
                          "delivery_fee",
                          e.target.value
                        )
                      }
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
          {selectedDeliveryFrom
            .filter((option) => option.active)
            .map((option, index) => {
              const isOpen = openStates[option.name] || false;
              const toggleOpen = () => {
                setOpenStates((prev) => ({
                  ...prev,
                  [option.name]: !prev[option.name],
                }));
              };
              return (
                <div
                  key={option.name}
                  className="md:w-full min-h-auto bg-[#FFFFFF] border mb-4 cursor-pointer"
                >
                  <div
                    onClick={toggleOpen}
                    className="w-full h-10 bg-[#C9ECF7] px-4  flex justify-between items-center font-medium text-base text-[#272728]"
                  >
                    {t(option?.name)}
                    <DownOutlined
                      className={`transition-transform duration-300 ${isOpen ? "rotate-180" : "rotate-0"
                        }`}
                    />
                  </div>
                  {isOpen && (
                    <>
                      <div className="mt-4">
                        <label className="font-medium text-base cursor-pointer mx-3 mt-4">
                          {t("Choose Delivery Agreement")}
                        </label>
                        <div className="flex flex-wrap mx-2 pb-6 pt-3">
                          <div className=" px-3">
                            <div
                              className={`flex items-center h-12 justify-center gap-2 mt-2 px-4 py-2 text-l font-semibold rounded-lg border shadow-sm cursor-pointer ${!option.supermarket_delivery
                                ? "text-blue-900 bg-[#EBF2FF] border-blue-900"
                                : "bg-white border border-[#C6C6C6] text-zinc-600"
                                }`}
                              onClick={() =>
                                toggleDeliveryAgreement(option.name, false)
                              }
                            >
                              <label className="font-medium text-base cursor-pointer">
                                {t("Company Delivery")}
                              </label>
                            </div>
                          </div>
                          <div key={option.name} className=" px-3">
                            <div
                              className={`flex items-center h-12 justify-center gap-2 mt-2 px-4 py-2 text-l font-semibold rounded-lg border shadow-sm cursor-pointer ${option.supermarket_delivery
                                ? "text-blue-900 bg-[#EBF2FF] border-blue-900"
                                : "bg-white border border-[#C6C6C6] text-zinc-600"
                                }`}
                              onClick={() =>
                                toggleDeliveryAgreement(option.name, true)
                              }
                            >
                              <label className="font-medium text-base cursor-pointer">
                                {t("Supermarket Delivery")}
                              </label>
                            </div>
                          </div>
                        </div>
                        <label className="font-medium text-base cursor-pointer m-3">
                          {t("Choose Payment Type")}
                        </label>
                        <div className="flex flex-wrap mx-4 pb-2 pt-4">
                          {option?.payment_methods
                            ?.filter((method) => method.name !== "Cash & Bank" && method.name !== "Credit") // Filter out unwanted methods
                            .map((method) => (
                              <div
                                key={method.name}
                                className="pe-3"
                                onClick={() =>
                                  togglePaymentMethod(option.id, method.name)
                                }
                              >
                                <div
                                  className={`flex items-center h-10 justify-center gap-2 mt-2 px-4 py-2 text-l font-semibold rounded-3xl border shadow-sm cursor-pointer ${method?.active
                                    ? "text-white bg-blue-900 border-blue-900"
                                    : "bg-white border border-[#C6C6C6] text-zinc-600"
                                    }`}
                                >
                                  <label className="font-medium text-base cursor-pointer">
                                    {t(method.name)}
                                  </label>
                                </div>
                              </div>
                            ))}

                          {/* {option?.payment_methods?.map((method) => (
                            <div
                              key={method.name}
                              className="pe-3"
                              onClick={() =>
                                togglePaymentMethod(option.id, method.name)
                              }
                            >
                              <div
                                className={`flex items-center h-10 justify-center gap-2 mt-2 px-4 py-2 text-l font-semibold rounded-3xl border shadow-sm cursor-pointer ${method?.active
                                  ? "text-white bg-blue-900 border-blue-900"
                                  : "bg-white border border-[#C6C6C6] text-zinc-600"
                                  }`}
                              >
                                <label className="font-medium text-base cursor-pointer">
                                  {t(method.name)}
                                </label>
                              </div>
                            </div>
                          ))} */}
                        </div>
                        <div className=" flex items-center justify-between pb-4">
                          <div className=" w-1/2 mx-4">
                            <InputBox
                              label={t("Commission Range (%)")}
                              name="storename"
                              placeholder={t("Enter Commission Percentage")}
                              maxLength={20}
                              value={option.commission_range || ""}
                              onChange={(e) =>
                                handleInputChange(
                                  option.id,
                                  "commission_range",
                                  e.target.value
                                )
                              }
                            />
                          </div>
                          {option.supermarket_delivery && (
                            <div className=" w-1/2 mx-4">
                              <InputBox
                                label={t("Delivery Fee (Optional)")}
                                name="storename"
                                placeholder={t("Enter Delivery Fee")}
                                maxLength={20}
                                value={option.delivery_fee || ""}
                                onChange={(e) =>
                                  handleInputChange(
                                    option.id,
                                    "delivery_fee",
                                    e.target.value
                                  )
                                }
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </div>
              );
            })}

          <div className="flex gap-5 mt-5  justify-end">
            {/* <button
              // onClick={() => onClose()}
              className="w-36 h-10 bg-white text-primaryBlue font-semibold rounded-lg inline border border-primaryBlue"
            >
              {t("cancel")}
            </button> */}
            <button
              // onClick={UpdateData}
              onClick={() => {
                if (checkPermission("/settings/cashiersetup", isGinne)) {
                  UpdateData();
                }
              }}
              className={`w-36 h-10 rounded-lg font-semibold ${hasChanges
                ? "bg-primaryBlue text-white"
                : "bg-primaryBlue text-white opacity-50 cursor-not-allowed"
                }`}
              disabled={!hasChanges}
            >
              {t("save")}
            </button>
          </div>
          {deliveryOptions?.some(item => item.active) && (
            <div className=" mt-8">
              <DeliveryCompanyTable
                //             deleteRow={(name) => {
                //   setSelectedDeliveryFrom((prev) =>
                //     prev.map(item =>
                //       item.name === name ? { ...item, active: false } : item
                //     )
                //   );
                //   toggleDeliveryFrom(event.target.value);
                // }}
                openDropdown={(name) =>
                  setOpenStates((prev) => ({
                    ...prev,
                    [name]: !prev[name],
                  }))
                }
                additionalData={deliveryOptions?.filter(item => item.active)}
              />
            </div>
          )}
        </div>
      ) : (
        <>
          <div className="flex justify-center w-full mt-16 text-base text-body text-center p-3 font-normal ">
            {t(
              "You cannot update cashier settings until your store is approved by myGINNE."
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default DeliveryCompanySetup;
